import { useState, useRef, useEffect } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/AboutUs" },
    { name: "Services", path: "/services" },
    { name: "Portfolio", path: "/portfolio" },
    { name: "Contact Us", path: "/Contact" },
    { name: "Download Portfolio" }, // no path
  ];

  const currentPath = location.pathname;
  const selected = navItems.find(item => item.path === currentPath)?.name || "";

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "hidden"; // prevent body scroll when menu open on mobile
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "unset";
    };
  }, [menuOpen]);

  return (
    <header className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
      <div className="w-full flex flex-col md:flex-row justify-between items-start md:items-center px-6 md:px-16 py-4 relative">
        {/* Logo */}
        <div className="flex justify-between items-center w-full md:w-auto">
          <button
            onClick={() => {
              navigate("/");
              setMenuOpen(false); // Optional: close menu if logo is clicked on mobile
            }}
            className="focus:outline-none"
            aria-label="Go to Home"
          >
            <img
              src="/images/ensologo.png"
              alt="Logo"
              className="h-20 w-auto max-w-[200px]"
            />
          </button>


          {/* Hamburger icon for mobile */}
          <div className="md:hidden">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="text-3xl focus:outline-none"
              aria-label={menuOpen ? "Close menu" : "Open menu"}
              aria-expanded={menuOpen}
              aria-controls="primary-navigation"
            >
              {menuOpen ? <FiX /> : <FiMenu />}
            </button>
          </div>
        </div>

        {/* Navigation */}
        <nav
          id="primary-navigation"
          ref={menuRef}
          className={`w-full md:w-auto bg-white md:bg-transparent shadow-md md:shadow-none mt-4 md:mt-0 text-center md:text-left transition-all duration-300 ease-in-out
        ${menuOpen ? "block" : "hidden"} md:flex md:items-center md:space-x-8`}
          role="navigation"
        >
          <ul className="flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-8 w-full md:w-auto">
            {navItems.map(({ name, path }) => (
              <li
                key={name}
                className={`cursor-pointer text-lg md:text-xl font-medium transition-colors duration-300 whitespace-nowrap px-4 py-2 rounded
              ${selected === name ? "text-red-500" : "text-black"}
              ${name === "Download Portfolio" ? "text-white bg-red-500 animate-blink" : ""}
              hover:underline`}
                onClick={() => {
                  setMenuOpen(false);
                  if (name === "Download Portfolio") {
                    const link = document.createElement("a");
                    link.href = "/portfolio/ensoportfolio.pdf";
                    link.download = "ensoportfolio.pdf";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  } else {
                    navigate(path);
                  }
                }}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    if (name === "Download Portfolio") {
                      const link = document.createElement("a");
                      link.href = "/portfolio/ensoportfolio.pdf";
                      link.download = "ensoportfolio.pdf";
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    } else {
                      navigate(path);
                    }
                    setMenuOpen(false);
                  }
                }}
              >
                {name}
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className="w-full h-1 bg-red-500"></div>
    </header>

  );
}
